export const TPC_LEGACY_FINANCE_SOURCE = Object.freeze({
  company: "TPC_Group",
  collectionBrand: "TechPerformanceCentre",
});

export const TPC_LEGACY_FINANCE_TARGET_BRAND = "shared";

export function isTpcLegacyFinanceScope(company, collectionBrand) {
  return (
    String(company || "").trim() === TPC_LEGACY_FINANCE_SOURCE.company &&
    String(collectionBrand || "").trim() === TPC_LEGACY_FINANCE_SOURCE.collectionBrand
  );
}

export function resolveFinancialClaimDataBrand(company, collectionBrand) {
  const brand = String(collectionBrand || "").trim();
  if (isTpcLegacyFinanceScope(company, brand)) {
    return TPC_LEGACY_FINANCE_TARGET_BRAND;
  }
  return brand;
}

export function resolveFinancialClaimFetchScopes(company, collectionBrand) {
  const dataBrand = resolveFinancialClaimDataBrand(company, collectionBrand);
  if (!dataBrand) return [];
  const scopes = [dataBrand];
  if (dataBrand !== TPC_LEGACY_FINANCE_TARGET_BRAND) {
    scopes.push(TPC_LEGACY_FINANCE_TARGET_BRAND);
  }
  return scopes;
}

export function buildFinancialClaimTenantPayload({
  company,
  collectionBrand,
  claim,
  fallbackCollectionBrand,
} = {}) {
  const requestedBrand = String(
    claim?._sourceCollectionBrand ||
      collectionBrand ||
      fallbackCollectionBrand ||
      TPC_LEGACY_FINANCE_TARGET_BRAND,
  ).trim();
  const authBrand = String(
    fallbackCollectionBrand ||
      collectionBrand ||
      claim?._sourceCollectionBrand ||
      TPC_LEGACY_FINANCE_TARGET_BRAND,
  ).trim();
  return {
    company,
    collectionBrand:
      resolveFinancialClaimDataBrand(company, requestedBrand) ||
      TPC_LEGACY_FINANCE_TARGET_BRAND,
    authCollectionBrand: authBrand || TPC_LEGACY_FINANCE_TARGET_BRAND,
  };
}
